// events/eventBus.ts
import { AppEventPayloadMap } from './eventTypes'

export function emitAppEvent<K extends keyof AppEventPayloadMap>(
  eventName: K,
  ...args: AppEventPayloadMap[K] extends undefined ? [] : [detail: AppEventPayloadMap[K]]
) {
  const detail = args[0]
  window.dispatchEvent(new CustomEvent(eventName as string, { detail }))
}

export function listenAppEvent<K extends keyof AppEventPayloadMap>(
  eventName: K,
  handler: (detail: AppEventPayloadMap[K]) => void,
): () => void {
  const listener = (e: Event) => {
    handler((e as CustomEvent<AppEventPayloadMap[K]>).detail)
  }
  window.addEventListener(eventName as string, listener)
  return () => window.removeEventListener(eventName as string, listener)
}
